import Slider from './Slider.ts';

class KV extends Slider {
	constructor() {
		super('.KV');
	}

	init() {
		super.init();
		this.$slider.on('afterChange', (e, slick, index) => {
			if (!index) this.$slider.slick('slickSetOption', 'autoplaySpeed', 3500);
			else  this.$slider.slick('slickSetOption', 'autoplaySpeed', 2500);
		});
		$(window).scroll(e => {
			const ypos = $("html").scrollTop() || $("body").scrollTop(), isOFF = (ypos > 80);
			this.$root.toggleClass('OFF', isOFF);
			if (isOFF) this.$slider.slick('slickPause');
			else this.$slider.slick('slickPlay');
		});
		return this;
	}
}

export default KV;


/** WEBPACK FOOTER **
 ** ./src/scripts/modules/KV.ts
 **/